import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { TEuDdpOrder } from 'redux/reducers/euDdp/types';
import { DATE_FILTER } from 'ui/EasTable/constants';
import {
	DELIVERY_STATUS_COLORS,
	DELIVERY_STATUS_FILTER,
	EEuDdpDeliveryStatusId,
	EuDdpOrderStatusId,
	ORDER_STATUS_COLORS,
	ORDER_STATUS_FILTER,
} from './constants';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { CUSTOMS_RESULT_COLORS, CUSTOMS_RESULT_FILTER } from '../../redux/reducers/euDdp/constants';

export const tableStructure: TTableStructure<keyof TEuDdpOrder>[] = [
	{
		selector: 'id',
		name: 'Id',
		show: false,
		sortable: true,
		filterable: false,
		separateFilter: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		key: true,
	},
	{
		selector: 'easOrderId',
		name: 'EAS Order ID',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'externalOrderId',
		name: 'External Order ID',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'emId',
		name: 'EM',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		value: (item: TEuDdpOrder) => {
			return { id: item.emId, name: item.fullName };
		},
	},
	{
		selector: 'origin',
		name: 'Origin',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'destination',
		name: 'Destination',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'deliveryCity',
		name: 'City',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'deliveryEmail',
		name: 'Recipient Email',
		show: false,
		sortable: true,
		filterable: false,
		searchable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'deliveryPhone',
		name: 'Recipient Phone',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'deliveryAddressLine1',
		name: 'Address Line 1',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'deliveryPostalCode',
		name: 'Postal Code',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'totalMerchAmount',
		name: 'Total Merch Amount',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'totalVatAmount',
		name: 'Total VAT',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'totalCustomsDuties',
		name: 'Total Customs Duty',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'actualVatAmount',
		name: 'Actual VAT',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'actualCustomsDuties',
		name: 'Actual Customs Duty',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'easFee',
		name: 'EAS Fee',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'firstMileTrackingNumber',
		name: 'First Mile Tracking',
		show: false,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'omnivaTrackingNumber',
		name: 'Omniva Tracking',
		show: false,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'customsLrnNumber',
		name: 'LRN',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'carrier',
		name: 'Carrier',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'paymentDate',
		name: 'Payment Date',
		show: true,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'labelRequestedAt',
		name: 'Label Requested At',
		show: false,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'labelGeneratedAt',
		name: 'Label Generated At',
		show: false,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'customsPassedAt',
		name: 'Customs Passed At',
		show: false,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'orderStatus',
		name: 'Shipment Status',
		show: true,
		sortable: false,
		filterable: true,
		type: ETableStructureType.STATUS_OBJECT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: ORDER_STATUS_FILTER,
		colors: ORDER_STATUS_COLORS,
	},
	{
		selector: 'orderStatusCode',
		name: 'Shipment Status Code',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: ORDER_STATUS_FILTER,
		colors: ORDER_STATUS_COLORS,
		value: (item: TEuDdpOrder) => {
			return item.orderStatus?.statusCode ?? '';
		},
	},
	{
		selector: 'orderStatusId',
		name: 'Shipment Status ID',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		value: (item: TEuDdpOrder) => {
			return String(item.orderStatus?.id ?? 0);
		},
	},
	{
		selector: 'deliveryStatus',
		name: 'Delivery Status',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS_OBJECT,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: DELIVERY_STATUS_FILTER,
		colors: DELIVERY_STATUS_COLORS,
	},
	{
		selector: 'customsResult',
		name: 'Customs result',
		show: true,
		sortable: true,
		filterable: true,
		filter: CUSTOMS_RESULT_FILTER,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		colors: CUSTOMS_RESULT_COLORS,
	},
	{
		selector: 'actions',
		noName: true,
		name: 'Actions',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		buttonFilter: (item: TEuDdpOrder) => {
			const buttons = [] as TTableStructureButton[];
			buttons.push({
				name: 'Tracking',
				color: 'primary.main',
				icon: EIconButtons.LOCAL_SHIPPING,
			});
			if (
				(!!item.orderStatus && item.orderStatus.id === EuDdpOrderStatusId.CLEARED) ||
				(!!item.orderStatus &&
					item.orderStatus.id === EuDdpOrderStatusId.DELIVERY_TO_END_CUSTOMER_ACCEPTED)
			) {
				buttons.push({
					label: 'Get Omniva label',
					icon: EIconButtons.CLOUD_DOWNLOAD,
					name: 'Get Omniva label',
				});
			}
			return buttons;
		},
	},
];
